import { render, staticRenderFns } from "./ConfirmBookingDialog.vue?vue&type=template&id=636ce9b0&"
import script from "./ConfirmBookingDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmBookingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports